var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-1 {\n        stroke: #fff;\n        stroke-width: 0.5px;\n      }\n\n      .cls-2 {\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.331,38.043a6.861,6.861,0,0,1-2.1-2.835c-1.805-3.8-2.184-9.144-2.184-12.961,0-.017,0-0.033,0-0.05A12.507,12.507,0,0,0,30.64,10.85V7.866A4.929,4.929,0,0,0,25.7,2.954H25.3a4.929,4.929,0,0,0-4.935,4.912V10.85a12.507,12.507,0,0,0-7.412,11.4c0,3.817-.379,9.165-2.184,12.961a6.86,6.86,0,0,1-2.1,2.835,1.253,1.253,0,0,0-.694,1.428,1.321,1.321,0,0,0,1.3,1.01h9.529a6.694,6.694,0,0,0,13.385,0h9.529a1.321,1.321,0,0,0,1.3-1.01,1.254,1.254,0,0,0-.694-1.428h0ZM22.961,7.866A2.333,2.333,0,0,1,25.3,5.542H25.7A2.333,2.333,0,0,1,28.04,7.866v2.146a12.665,12.665,0,0,0-5.079,0V7.866ZM25.5,44.459a4.09,4.09,0,0,1-4.093-3.978h8.185A4.09,4.09,0,0,1,25.5,44.459h0Zm5.235-6.566H12.242a13.554,13.554,0,0,0,.681-1.188c1.742-3.414,2.626-8.278,2.626-14.458a9.951,9.951,0,0,1,19.9,0c0,0.016,0,.032,0,0.048,0,6.155.888,11,2.626,14.406a13.581,13.581,0,0,0,.681,1.188H30.735Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,29l22-6s0.333,6.5,2,10,3,6,3,6H11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.29155e975eaeff8669bfa460b5bc49fd.svg";
export { ForwardRef as ReactComponent };